import React, { memo } from 'react';
import { AlgoliaModifiedQueryData } from '../../interfaces/AlgoliaModifiedQueryData.interface';
import { CTABarSmallBlokProps } from '../CTABarSmall/CTABarSmall';
import GroupedArticleIndexPageResultsSectionLight from './GroupedArticleIndexPageResultsSectionLight';
import GroupedArticleIndexPageResultsSectionAlt from './GroupedArticleIndexPageResultsSectionAlt';

export interface GroupedArticleSection {
  title: string;
  articles: AlgoliaModifiedQueryData[];
}

interface GroupedArticleIndexPageResultsMainAreaProps {
  articleSections: GroupedArticleSection[];
  ctaBar: CTABarSmallBlokProps[];
  onScroll: () => void;
}

const GroupedArticleIndexPageResultsMainArea: React.FC<
  GroupedArticleIndexPageResultsMainAreaProps
> = ({ articleSections, ctaBar, onScroll }) => {
  return (
    <article onWheel={onScroll}>
      {articleSections.map((section: GroupedArticleSection, index) => (
        <>
          {index % 2 === 0 ? (
            <GroupedArticleIndexPageResultsSectionLight
              key={section.title}
              section={section}
              ctaBar={ctaBar}
              index={index}
            />
          ) : (
            <GroupedArticleIndexPageResultsSectionAlt
              key={section.title}
              section={section}
              ctaBar={ctaBar}
              index={index}
            />
          )}
        </>
      ))}
    </article>
  );
};

export default memo(GroupedArticleIndexPageResultsMainArea);
